// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'
import {imageUrlToBase64} from "../../../../utility/Utils";

export const setLoading = createAsyncThunk('PurchaseInvoiceReturnCustomization/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('PurchaseInvoiceReturnCustomization/getData', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    const response = await axios.get('/InvoicePreviewCustomization/GetPurchaseReturnInvoiceCustomization', { params })
    if(response.data.data.showHeaderImage && response.data.data.headerImage) {
        try {
            response.data.data.headerImageBase64 = await imageUrlToBase64(process.env.REACT_APP_API_URL_production + response.data.data.headerImage);
        } catch(error) {
            console.log(error);
        }
    }

    dispatch(setLoading({ getData: false }))

    return {
        params,
        data: response.data,
    }
})

export const getBank = createAsyncThunk('PurchaseInvoiceReturnCustomization/getBank', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    const response = await axios.get('/Locations/GetBankDetails', { params })
    dispatch(setLoading({ getData: false }))
    return {
        params,
        data: response.data,
    }
})

export const PurchaseInvoiceReturnCustomizationSlice = createSlice({
    name: 'PurchaseInvoiceReturnCustomization',
    initialState: {
        data: {},
        bank_data: {},
        params: {},
        loadingState: { getData: false }
        // allData: []
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data.data
                state.params = action.payload.params
            })
            .addCase(getBank.fulfilled, (state, action) => {
                state.bank_data = action.payload.data.data
                state.params = action.payload.params
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState = action.payload
            })
    }
})

export default PurchaseInvoiceReturnCustomizationSlice.reducer
